// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3-iUF","colMin":"styles_colMin__2TgNZ","colCheckbox":"styles_colCheckbox__3B-Pt"};